import { cn, formatPrice } from '@/lib/utils';

interface PriceProps {
  value: string;
  compareAt?: string | null;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

const sizes = {
  sm: { current: 'text-base', compare: 'text-xs' },
  md: { current: 'text-lg', compare: 'text-sm' },
  lg: { current: 'text-2xl', compare: 'text-base' },
} as const;

/**
 * Fiyat her zaman grotesk ve hizalı rakamlarla yazılır (PRODUCT-DECISIONS §1.3).
 * İndirimli fiyatta eski değer gri ve üstü çizili; kırmızı bağırmaz.
 */
export function Price({ value, compareAt, size = 'md', className }: PriceProps) {
  const scale = sizes[size];
  const hasDiscount = Boolean(compareAt && compareAt !== value);

  return (
    <span className={cn('inline-flex items-baseline gap-2', className)} data-price>
      {hasDiscount ? (
        <span
          className={cn('text-ink-subtle line-through', scale.compare)}
          aria-label="Eski fiyat"
        >
          {formatPrice(compareAt as string)}
        </span>
      ) : null}

      <span className={cn('font-medium text-ink', scale.current)}>
        {formatPrice(value)}
      </span>
    </span>
  );
}
